import { render } from "./AtencionResumen.vue?vue&type=template&id=919385c8&scoped=true"
import script from "./AtencionResumen.vue?vue&type=script&lang=js"
export * from "./AtencionResumen.vue?vue&type=script&lang=js"

import "./AtencionResumen.vue?vue&type=style&index=0&id=919385c8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-919385c8"]])

export default __exports__